import { useContext } from 'react';
import { ErrorContext } from '@xingternal/content-error';

const useError = () => {
  const context = useContext(ErrorContext);

  if (!context) {
    throw new Error(
      'You need to wrap the component inside ErrorProvider component to use useError',
    );
  }

  return context;
};

export { useError };
